'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Feedback = require('./Feedback');

var _Feedback2 = _interopRequireDefault(_Feedback);

var _store = require('../util/store');

var store = _interopRequireWildcard(_store);

var _slugify = require('../util/slugify');

var _slugify2 = _interopRequireDefault(_slugify);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedbackWidget = function (_Component) {
    _inherits(FeedbackWidget, _Component);

    function FeedbackWidget() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FeedbackWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeedbackWidget.__proto__ || Object.getPrototypeOf(FeedbackWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            hidden: false
        }, _this.slug = 'feedback-' + (0, _slugify2.default)(_this.props.children.toString()), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FeedbackWidget, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.settings.persistentHide) {
                var storedSettings = store.get(this.slug);
                if (storedSettings.hidden) {
                    this.setHiddenState(true);
                }
            }
        }
    }, {
        key: 'setHiddenState',
        value: function setHiddenState(hidden) {
            this.setState({ hidden: hidden });
        }
    }, {
        key: 'closeFeedback',
        value: function closeFeedback() {
            this.setState({ hidden: true });
            if (this.props.settings.persistentHide) {
                store.set(this.slug, { hidden: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var feedbackIsHidden = this.state.hidden;

            if (feedbackIsHidden) {
                return null;
            }
            return _react2.default.createElement(
                _Feedback2.default,
                {
                    closeFeedback: function closeFeedback() {
                        return _this2.closeFeedback();
                    },
                    settings: this.props.settings,
                    theme: this.props.theme
                },
                this.props.children
            );
        }
    }]);

    return FeedbackWidget;
}(_react.Component);

FeedbackWidget.propTypes = {
    children: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
    settings: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    theme: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};
FeedbackWidget.defaultProps = {
    children: {},
    settings: {}
};
exports.default = FeedbackWidget;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/feedback/lib/cjs/FeedbackWidget/index.js
 ** module id = 725
 ** module chunks = 1
 **/